function timeout(milliseconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error("Request timed out."));
    }, milliseconds);
  });
}
function fetchWithTimeout(resource, options) {
  const controller = new AbortController();
  return Promise.race([
    fetch(resource, {
      ...options,
      signal: controller.signal
    }),
    timeout(options.timeout)
  ]).catch((error) => {
    if (error.message === "Request timed out.") {
      controller.abort();
    }
    return new Response(null, { status: 408, statusText: "Request timed out." });
  });
}

export { fetchWithTimeout };
//# sourceMappingURL=timeout.js.map
